"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TransformMode = void 0;

var _helpers = require("@turf/helpers");

var _translateMode = require("./translate-mode");

var _scaleMode = require("./scale-mode");

var _rotateMode = require("./rotate-mode");

var _compositeMode = require("./composite-mode");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);

      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var TransformMode = /*#__PURE__*/function (_CompositeMode) {
  _inherits(TransformMode, _CompositeMode);

  var _super = _createSuper(TransformMode);

  function TransformMode() {
    _classCallCheck(this, TransformMode);

    return _super.call(this, [new _translateMode.TranslateMode(), new _scaleMode.ScaleMode(), new _rotateMode.RotateMode()]);
  }

  _createClass(TransformMode, [{
    key: "handlePointerMove",
    value: function handlePointerMove(event, props) {
      var updatedCursor = null;

      _get(_getPrototypeOf(TransformMode.prototype), "handlePointerMove", this).call(this, event, _objectSpread({}, props, {
        onUpdateCursor: function onUpdateCursor(cursor) {
          updatedCursor = cursor || updatedCursor;
        }
      }));

      props.onUpdateCursor(updatedCursor);
    }
  }, {
    key: "handleStartDragging",
    value: function handleStartDragging(event, props) {
      var scaleMode = null;
      var translateMode = null;
      var filteredModes = []; // If the user selects a scaling edit handle that overlaps with part of the selected feature,
      // it is possible for both scale and translate actions to be triggered. This logic prevents
      // this simultaneous action trigger from happening by putting a higher priority on scaling
      // since the user needs to be more precise to hover over a scaling edit handle.

      this._modes.forEach(function (mode) {
        if (mode instanceof _translateMode.TranslateMode) {
          translateMode = mode;
        } else {
          if (mode instanceof _scaleMode.ScaleMode) {
            scaleMode = mode;
          }

          filteredModes.push(mode);
        }
      });

      if (scaleMode instanceof _scaleMode.ScaleMode && !scaleMode.isEditHandleSelected()) {
        filteredModes.push(translateMode);
      }

      filteredModes.filter(Boolean).forEach(function (mode) {
        return mode.handleStartDragging(event, props);
      });
    }
  }, {
    key: "getGuides",
    value: function getGuides(props) {
      var compositeGuides = _get(_getPrototypeOf(TransformMode.prototype), "getGuides", this).call(this, props);

      var rotateMode = (this._modes || []).find(function (mode) {
        return mode instanceof _rotateMode.RotateMode;
      });

      if (rotateMode instanceof _rotateMode.RotateMode) {
        var nonEnvelopeGuides = compositeGuides.features.filter(function (guide) {
          var _ref = guide.properties || {},
              editHandleType = _ref.editHandleType,
              mode = _ref.mode; // Both scale and rotate modes have the same enveloping box as a guide - only need one


          var guidesToFilterOut = [mode]; // Do not render scaling edit handles if rotating

          if (rotateMode.getIsRotating()) {
            guidesToFilterOut.push(editHandleType);
          }

          return !guidesToFilterOut.includes('scale');
        }); // @ts-ignore

        compositeGuides = (0, _helpers.featureCollection)(nonEnvelopeGuides);
      }

      return compositeGuides;
    }
  }]);

  return TransformMode;
}(_compositeMode.CompositeMode);

exports.TransformMode = TransformMode;